import { timer, map, BehaviorSubject, filter } from "rxjs";
import { io } from "socket.io-client"
import { configService } from "./config.service";

class MirrorService {
	constructor() {
		this.howOften = 500;	//milliseconds

		this.timer$ = null;
		this.mirrorTreeLocal$ = new BehaviorSubject(null);
		this.mirrorTreeRemote$ = new BehaviorSubject(null);

		this.curRoot = {};

		this.mirrorComponent = null;

		this.mirrorIgnore = null;
		this.mirrorSend = true;
		this.mirrorReceive = true;
	}

	init = (mirrorComponent, send = null, receive = null) => {
		this.mirrorComponent = mirrorComponent;

		configService.config$
			.pipe(filter(config => config !== null))
			.subscribe((config) => {
				let options = {
					transportOptions: {
						polling: {
							extraHeaders: {
								'Authorization': `Bearer ${config.token}`,
							},
						},
					},
					query: {
						mirror: config.name
					}
				}

				this.socket = io(`${config.mirrorURL}/mirror`, options);
				
				this.mirrorIgnore = config.mirrorIgnore || null;
				this.mirrorSend = send === null ? config.mirrorSend : send;
				this.mirrorReceive = receive === null ? config.mirrorReceive : receive;

				if(this.mirrorSend || this.mirrorReceive)
					console.log(`Mirroring: Send(${this.mirrorSend}) - Receive(${this.mirrorReceive})`);

				if(this.mirrorReceive) {
					this.socket.on('mirror', (mirrorTree) => {
						if (JSON.stringify(mirrorTree.tree) != JSON.stringify(this.curRoot))
						{
							this.curRoot = mirrorTree.tree;
							this.mirrorTreeRemote$.next(mirrorTree.tree);
							this.UpdateMirrorComponent(mirrorTree.tree);
						}
					});
				}

				if(this.mirrorSend) {
					this.SetMirrorComponent(mirrorComponent);
				}
			});
	}

	SetMirrorComponent(mirrorComponent){
		if (this.timer$ != null){
			this.timer$ = null;
			this.timer$.unsubscribe();
		}

		this.timer$ = timer(1, this.howOften)
		.subscribe(() => {
			this.CheckMirrorUpdate(mirrorComponent);
		});
	}

	CheckMirrorUpdate(mirrorComponent){
		let rootState = this.RemoveIgnoredStates(mirrorComponent.state);
		let root = {state: rootState, children: []};
		let queue = [];

		// BFS Traversal
		queue.push([mirrorComponent.mirrorRefs, root.children]);
		while (queue.length !== 0)
		{
			let node = queue.shift();
			
			if (node[0] != null && node[0] != undefined)
			{
				node[0].forEach(mirrorRef => {
					if (mirrorRef.current != null){
						let cleanedState = this.RemoveIgnoredStates(mirrorRef.current.state);
						node[1].push({state: cleanedState, children: []});
						queue.push([mirrorRef.current.mirrorRefs, node[1][node[1].length - 1].children]);
					}
					else{
						node[1].push({state: {}, children: []});
					}
				});
			}
		}

		if (JSON.stringify(root) != JSON.stringify(this.curRoot)){
			this.curRoot = root;
			this.mirrorTreeLocal$.next(root);
			this.socket?.emit('mirror', root);
		}
	}

	UpdateMirrorComponent(mirrorTree){
		let queue = [];

		// BFS Traversal
		queue.push([this.mirrorComponent, mirrorTree]);
		while (queue.length !== 0)
		{
			let node = queue.shift();
			if (node[0] !== null)
			{
				node[0].setState(node[1]?.state);

				node[0].mirrorRefs?.forEach(mirrorRef => {
					queue.push([mirrorRef.current, node[1]?.children.shift()]);
				});
			}

		}
	}

	RemoveIgnoredStates(state){
		
		if (state != undefined)
		{
			state = JSON.parse(JSON.stringify(state));
			this.mirrorIgnore?.stateVars?.forEach(stateVar => {
				delete state[stateVar];
			});
		}
		return state;
	}

}

export const mirrorService = new MirrorService();